import { EDCServiceResponse, NServiceResponse } from "@/models/EstadoCuenta/NewServiceResponse";
import FechaCorte from "@/models/EstadoCuenta/FechaCorte";
import { AxiosResponse } from "axios";
import BaseService from "./BaseService";
import EDCB64 from "@/models/EstadoCuenta/EDFBase64";
import EstadoCuentaPDFRequest from "@/models/EstadoCuenta/EstadoCuentaPDFRequest";

export default class EstadoCuentaService extends BaseService<any> {
    public constructor() {
      super("EstadoCuenta");
    }

    public async getFechaCorte(
      userIdentity: string,
      userIdentityEncrypted: string,
      tokenUser: string
    ): Promise<AxiosResponse<NServiceResponse<Array<FechaCorte>>>> {
      const action = `GetCortes/${userIdentityEncrypted}/${userIdentity}/${tokenUser}`;
      return this.get(action);
    }
      public async getEDCPdfBase64(
        payload: EstadoCuentaPDFRequest
      ): Promise<AxiosResponse<NServiceResponse<EDCB64>>> {
        let action: string =`GetEstadoCuenta?`; 
        return this.post(action, { ...payload});
      }
}   